import { cn } from '@divlab/divanui';

import { useProfile } from '@Queries/Profile';
import useTranslation from '@Queries/useTranslation';
import Button from '@UI/Button';
import styles from './BonusTypes.module.css';

import type { FC, HTMLAttributes } from 'react';

interface BonusTypesProps extends HTMLAttributes<HTMLDivElement> {
  bonusTypes: BonusTypesData;
}

export type BonusTypesData = {
  title: string;
  items: {
    icon: string;
    title: string;
    points: string[];
  }[];
};

const BonusTypes: FC<BonusTypesProps> = (props) => {
  const { className, bonusTypes, ...restProps } = props;
  const { t } = useTranslation();
  const { data: profile } = useProfile();
  const button = t('form.registration');

  return (
    <div className={cn(styles.wrapper, className)} {...restProps}>
      <div className={styles.title}>{bonusTypes.title}</div>
      <div className={styles.bonusTypes}>
        {bonusTypes.items.map((bonusType) => (
          <div className={styles.type} key={bonusType.title}>
            <div className={styles.top}>
              <img className={styles.image} src={bonusType.icon} />
              <div className={styles.subtitle}>{bonusType.title}</div>
            </div>
            <div className={styles.points}>
              {bonusType.points.map((bonusPoint) => (
                <div className={styles.point} key={bonusPoint}>
                  {bonusPoint}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {!profile && (
        <Button className={styles.link} to='#authorization' theme='transparent'>
          {button}
        </Button>
      )}
    </div>
  );
};

export default BonusTypes;
